import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

interface ItemType {
    img: [string, string];
    name: string;
    text: string;
}
const D: React.FC = () => {
    const { t } = useLang('d3u');
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760695210418/4_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760695209721/4_1_M.jpg'],
            name: t('D_item1_name'),
            text: t('D_item1_text'),
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760695209791/4_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760695210082/4_2_M.jpg'],
            name: t('D_item2_name'),
            text: t('D_item2_text'),
        },
    ];

    return (
        <section className={`${css.section} D3U-D GtmModuleData-section`} id="D3U-D" data-section-id={'D3U-D'} data-section-id2={t('D_title')}>
            <div className="info">
                {/* <p className="label">{t('D_label')}</p> */}
                <p className="title">{t('D_title')}</p>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className="item" key={k}>
                        <div className="img">
                            <EcoImg pc={item.img[0]} h5={item.img[1]} />
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default D;
